import { Heading } from '../../../base/Heading/Heading';
import { SearchPage } from '../../../widget/Pages/Pages';
import { JourneyPlanForm } from '../Form/PlanForm/JourneyPlanForm';
import {
  submitJourneyPlanForm,
  type JourneyPlanFormModel,
} from '../Form/PlanForm/JourneyPlanForm.types';

interface JourneyPlanSearchPageProps {
  form: JourneyPlanFormModel;
  onShowResults: () => void;
}

export function JourneyPlanSearchPage({
  form,
  onShowResults,
}: JourneyPlanSearchPageProps) {
  return (
    <SearchPage variant="onBrand">
      <Heading as="h2" variant="lg">
        Plan Your Journey
      </Heading>
      <JourneyPlanForm
        form={form}
        mode="search"
        onSubmit={submitJourneyPlanForm(form, onShowResults)}
      />
    </SearchPage>
  );
}
